import React, { useContext } from "react";
import { Typography, IconButton, Tooltip, Stack, Divider } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { getRuta, isAccess } from "../../../helpers/Helpers";
import { DataContext } from "../../../context/DataContext";

const ClientCount = ({ value }) => {

  const { access } = useContext(DataContext);
  let ruta = getRuta();
  let navigate = useNavigate();

  return (
    <div>
      <Stack
        direction={"row"}
        style={{ padding: 10 }}
        justifyContent="space-between"
        alignItems={"center"}
      >
        <Tooltip title="Ver Clientes Activos">
          <IconButton
            disabled={!isAccess(access, "RCLIENTS")}
            sx={{ border: 1, borderColor: "rgba(255, 206, 86, 1)" }}
            style={{
              width: 100,
              height: 100,
              backgroundColor: "rgba(255, 206, 86, 0.2)",
            }}
            onClick={() => navigate(`${ruta}/dash-clients`)}
          >
            <FontAwesomeIcon
              icon={faUsers}
              style={{
                fontSize: 60,
                color: "rgba(255, 206, 86, 1)",
                opacity: 0.3,
                padding: 10,
              }}
            />
          </IconButton>
        </Tooltip>
        <Typography
          align="right"
          style={{
            color: "rgba(255, 206, 86, 1)",
            fontWeight: 800,
            fontSize: 30,
          }}
          paragraph
        >
          {value}
        </Typography>
      </Stack>
      <Divider />
      <Typography
        variant="subtitle1"
        align="center"
        style={{ color: "rgba(255, 206, 86, 1)", fontSize: 20 }}
      >
        Clientes Activos
      </Typography>
    </div>
  );
};

export default ClientCount;
